import React from 'react';
import { Toaster } from 'react-hot-toast';
import { ThemeProvider } from './hooks/useTheme';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import FloatingWhatsApp from './components/ui/FloatingWhatsApp';
import HeroSection from './components/home/HeroSection';
import ServicesSection from './components/home/ServicesSection';
import TechnologiesSection from './components/home/TechnologiesSection';
import GallerySection from './components/home/GallerySection';
import TestimonialsSection from './components/home/TestimonialsSection';
import ContactSection from './components/contact/ContactSection';
import './styles/globals.css';

export default function App() {
  return (
    <ThemeProvider>
      <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
        <Navbar />
        <main style={{ flex: 1 }}>
          <div id="anasayfa"><HeroSection /></div>
          <section id="hizmetler"><ServicesSection /></section>
          <section id="teknolojiler"><TechnologiesSection /></section>
          <section id="galeri"><GallerySection /></section>
          <section id="yorumlar"><TestimonialsSection /></section>
          <section id="iletisim"><ContactSection /></section>
        </main>
        <Footer />
        <FloatingWhatsApp />
        <Toaster
          position="top-right"
          toastOptions={{
            style: {
              background: 'var(--bg-card)',
              color: 'var(--text-primary)',
              border: '1px solid var(--border-color)',
              fontFamily: 'var(--font-body)',
            },
          }}
        />
      </div>
    </ThemeProvider>
  );
}
